import { useEffect } from 'react';

export const useAsyncErrorLog = ({ error }) => {
	useEffect(() => {
		// TODO: use debug
		// eslint-disable-next-line no-console
		if (error) console.error(error);
	}, [error]);
};
